/*
 * @Author: Risker-C
 * @Date: 2021-09-13 16:28:00
 * @LastEditTime: 2021-09-18 16:20:43
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\business\view\PageHeader.tsx
 */
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import React from "react";
import { useBusinessModel } from "../businessModel";



export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        categoryOption
    } = useBusinessModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "业务范围",
            fieldName: "columnCode",
            options: categoryOption
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "创建人",
        //     fieldName: "createUser"
        // },
        {
            type: SearchTypeEnum.Datepicker,
            fieldName: "createTime",
            placeholder: "创建时间",
            format: "YYYY-MM-DD",
        },
    ]

    return (
        <YhPageHeader
            title="业务范围"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, params)}
            handleReset={resetSearchParam}
        />
    );
}